<template>
		<v-text-field
			v-model="setPosition"
			label="役職"
			class="mt-4"
			outlined
			dense
		/>
</template>

<script>
export default {
	props: {
		position: {
			type: String,
			default: "",
		},
	},
	computed: {
		setPosition: {
			get() {
				return this.position
			},
			set(newValue) {
				return this.$emit("update:position", newValue)
			},
		},
	},
}
</script>
